/* eslint indent: 0 */

import './media_library.breadcrumbs.less';

import debounce from 'lodash/debounce';
import _each from 'lodash/each';

import Backbone from 'backbone';

import mediaLibraryBreadcrumbsTemplate from './media_library.breadcrumbs.tpl';

import zfHelpers from 'zoomforth_tools/modern_helpers.js';

const MediaLibraryBreadcrumbs = Backbone.View.extend({
    attributes: {},
    
    events: {
      'click .action-navigate-to-folder': 'clickedBreadcrumb',
      'click .action-sort-by': 'showSortByOptions',
      'click .action-breadcrumbs-dropdown': 'showBreadcrumbsDropdown',
      'click .action-sort-option': 'sortOptionClicked',
      'click .toggle-btn': 'changeAssetDisplay',
      'click .action-clear-search': 'clearSearch'
    },
    
    className: 'media-library-breadcrumbs',
    
    initialize: function(options){
      this.currentFolder = options.currentFolder;
      this.navState = options.navState;
      this.listenTo(this.currentFolder, 'change', this.render);
      this.dropdownBreadcrumbs = [];
      this._bindResize();
    },
    
    render: function() {
      this.dropdownBreadcrumbs = [];
      var breadcrumbs = this._calculateBreadcrumbsWidth();
      this.$el.html(mediaLibraryBreadcrumbsTemplate({
        assetDisplayState: this.navState.get('asset_display_type'),
        dropdownBreadcrumbs: this.dropdownBreadcrumbs,
        parentFolders: breadcrumbs.parentFolders,
        currentFolder: this.currentFolder,
        sortBy: this.navState.get('sort_by'),
        getSortByName: this.getSortByName,
        isSearchContext: this.navState.getIsSearching()
      }));
      this.$el.find('.current-folder').css('max-width', breadcrumbs.availableSpace);
      return this;
    },
    
    remove: function() {
      $(window).unbind('resize.breadcrumbs'); 
      MediaLibraryBreadcrumbs.__super__.remove.call(this);
    }, 
    
    _bindResize: function(){
      var me = this;
      $(window).unbind('resize.breadcrumbs').bind('resize.breadcrumbs', debounce(function(){
        me.render();
      }, 500));
    },
    
    _calculateBreadcrumbsWidth: function() {
      // Holy magic number batman! 40 pixels for left padding, 215 for sort options text, and 350 for the info panel
      var me = this; 
      var leftPaddingWidth = 40;
      var sortOptionsWidth = 210;
      var infoPanelWidth = 350;
      var breadcrumbsDropdownWidth = 110;
      var magicNumber = leftPaddingWidth + sortOptionsWidth + infoPanelWidth;
      if(this.dropdownBreadcrumbs) {
        magicNumber += breadcrumbsDropdownWidth;
      }
      var availableSpace = $(window).width() - magicNumber;
      var availableCharacters;
      var pixelsPerCharacter = 10;
      var currentFolderName = this.currentFolder.get('name');
      var index;
      var myParents = this.currentFolder.getParents();
      
      var breadcrumbsArray = [];
      
      if(availableSpace) {
        availableCharacters = parseInt(availableSpace / pixelsPerCharacter - currentFolderName.length);
        _each(myParents.reverse(), function(parentFolder) {
          if(availableCharacters - parentFolder.get('name').length > 0) {
            breadcrumbsArray.unshift(parentFolder);
            availableCharacters -= (parentFolder.get('name').length + 3);
          } else {
            availableCharacters = 0;
            me.dropdownBreadcrumbs.unshift(parentFolder);
          }
        });
      } else {
        this.dropdownBreadcrumbs = this.currentFolder.getParents();
      }
      return {
        'parentFolders': breadcrumbsArray, 
        'availableSpace':  availableSpace
      };
    }, 
    
    _getFolderIdFromBreadcrumb: function($breadcrumb){
      var folderId = $breadcrumb.attr('data-folder-id');
      if (!folderId || folderId === 'null') {
        folderId = null;
      } else {
        folderId = parseInt(folderId)
      }
      return folderId;
    },
    
    clickedBreadcrumb: function(e) {
      var folderId = this._getFolderIdFromBreadcrumb($(e.currentTarget));
      var folder = this.currentFolder.collection.findWhere({
        id: folderId 
      });
      this.trigger('navigate', folder)
    },
    
    showSortByOptions: function(){
      zfHelpers.showDropdown(this.$('.sort-by-dropdown'));    
    },
    
    sortOptionClicked: function(e){
      var sortMethod = $(e.currentTarget).attr('data-sort-type');
      this.navState.navigate({
        sort_by: sortMethod
      });
    },
    
    clearSearch: function(){
      this.navState.clearSearch();
    }, 
    
    showBreadcrumbsDropdown: function(e) {
      zfHelpers.showDropdown(this.$('.breadcrumbs-dropdown'));  
    },
    
    getSortByName: function(sortBy) {
      return ({
        'date_modified:desc': 'Date Modified',
        'date_added:desc': 'Date Added',
        'display_filename:asc': 'Name (A-Z)'
      })[sortBy];
    },

    changeAssetDisplay: function(e){
      var targetAssetDisplay = $(e.currentTarget).attr('data-display-type');
      if (targetAssetDisplay === this.navState.get('asset_display_type')) {
        return;
      }
      this.navState.navigate({ asset_display_type: targetAssetDisplay });
    }
    
  });
  
export default MediaLibraryBreadcrumbs;